/**
 * Created by Mattias on 2014-10-09.
 */
define('payment/handlers/sendHandlers/resultAfterSingleCallHandler',['jquery'], function($) {
        'use strict';

        var methodName;

        function init(methodNameIn){
            methodName = methodNameIn;
        }

        function createExtraPaymentInfo(paymentBox, sendHandlerData) {
            if (typeof(sendHandlerData.parameterMap) === 'undefined' || typeof(sendHandlerData.parameterMap.messages) === 'undefined') {
                return;
            }

            var $div = $('<div>'),
                $messageDiv = $('<div>');

			// OBS! UkashExecuteDeposit used messages, not used any more, so this method can probably be removed
			// Together with all 'provider-html' handling
			// It is also some setting of "pending-message" in ExecutePaymentResponseFactory and in BWExecuteDepositJson (not used any more)
			// That does not seem to be used any more
            $.each(sendHandlerData.parameterMap.messages, function (index, item) {
                var $element = $('<div>'),
                    $strong = $('<strong>').text(item.key + ': '),
                    $span = $('<span>').text(item.value);

                $strong.appendTo($element);
                $span.appendTo($element);
                $element.appendTo($messageDiv);
            });

            $messageDiv.appendTo($div);
            paymentBox.$controller.trigger('provider-html', $div);
        }

        function handleSuccessfulResponse(paymentBox, sendHandlerData, accHistRef, paymentFetchResultFlow){
            if (typeof(sendHandlerData) !== 'undefined' && sendHandlerData !== null) {
                createExtraPaymentInfo(paymentBox, sendHandlerData);
            }
            window.top.getPaymentResult.getSynchronousDepositResultAndShowFinalResult(accHistRef, paymentFetchResultFlow);
        }

        function cleanupOnFail() {}

        var resultAfterSingleCall = {};
        resultAfterSingleCall.init = init;
        resultAfterSingleCall.handleSuccessfulResponse = handleSuccessfulResponse;
        resultAfterSingleCall.cleanupOnFail = cleanupOnFail;

        return resultAfterSingleCall;
    }
);

